import React from 'react';
import PropTypes from "prop-types";

import SvgCircularLoader from 'components/svg/CircularLoader';

class Loader extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            opacity: 0,
        };
        this.showLoaderTimer = null;
        this.hideLoaderTimer = null;
        this.opacityRanges = [0, 1];
    }

    componentDidUpdate(prevProps) {
        const { isLoading, animate } = this.props;
        const startedLoading = !prevProps.isLoading && isLoading;
        const stoppedLoading = prevProps.isLoading && !isLoading;

        if (startedLoading) {
            this.showHideLoader(true, animate);
        }

        if (stoppedLoading) {
            this.showHideLoader(false, animate);
        }
    }

    showHideLoader(show = true, animate) {
        if (animate) {
            this.animatedShowHideLoader(show);
        } else {
            this.nonAnimatedShowHideLoader(show);
        }
    }

    animatedShowHideLoader(show) {
        const that = this;
        const step = 0.1;
        const {opacityRanges} = this;
        const timerDelay = 50;
        const timer = show ? 'showLoaderTimer' : 'hideLoaderTimer';
        let newValue = null;

        this.clearActiveInterval(show);

        this[timer] = setInterval(function() {
            const opacityWithStepApplied = show
                ? that.state.opacity + step
                : that.state.opacity - step;

            newValue = Math.round((opacityWithStepApplied) * 10) / 10;

            const opacityOverTheLimit = show ? (newValue >= opacityRanges[1]) : (newValue <= opacityRanges[0]);
            const finalOpacityValue = show ? opacityRanges[1] : opacityRanges[0];

            if (opacityOverTheLimit) {
                clearInterval(timer);
                that.setState({opacity: finalOpacityValue});
            } else {
                that.setState({opacity: newValue});
            }
        }, timerDelay);
    }

    nonAnimatedShowHideLoader(show) {
        if (show) {
            this.setState({opacity: this.opacityRanges[1]});
        } else {
            this.setState({opacity: this.opacityRanges[0]});
        }
    }

    clearActiveInterval(show) {
        clearInterval(show ? this.hideLoaderTimer :this.showLoaderTimer);
    }

    render() {
        const { opacity } = this.state;
        const { isLoading } = this.props;
        const styles = {
          opacity,
        };
        const hideLoader = (opacity === 0 && !isLoading);

        if (hideLoader) return null;

        return (
          <div className='loader' style={styles}>
              <SvgCircularLoader className='loader-icon' />
          </div>
        );
    }
}

Loader.propTypes = {
    isLoading: PropTypes.bool,
    animate: PropTypes.bool,
};

Loader.defaultProps = {
    isLoading: false,
    animate: false,
};

export default Loader;